import axios from "axios";
const URL = process.env.REACT_APP_API_URL;

export interface ICard {
  profileType: string;
  quantity: number;
  density: number;
  filledFields: {
    name: string;
    value: number;
    shortName: string;
  }[];
}

interface IReqest {
  items: ICard[];
}

export const createUserCardService = (userId: string) => {
  return axios.post(`${URL}/cart/${userId}`);
};
export const fetchCartByIdService = (cartId: string) => {
  return axios.get(`${URL}/cart/${cartId}`);
};
export const fetchCardItemsService = (cartId) => {
  return axios.get(`${URL}/cart/${cartId}`);
};
export const clearCartService = (cartId: string) => {
  return axios.delete(`${URL}/cart/${cartId}/clear`);
};
export const downloadCardService = (cartId: string) => {
  return axios.get(`${URL}/cart/${cartId}/download`);
};
export const handleValuationService = (cartId: string, payload: any) => {
  return axios.post(`${URL}/cart/${cartId}/send`, payload);
}; 
export const addItemToCardService = (cardId: string, payload: any) => {
  return axios.post(`${URL}/cart-item/${cardId}`, payload);
};
export const removeCardItemService = (cartItemId: string) => {
  return axios.delete(`${URL}/cart-item/${cartItemId}`);
};
export const updateCardItemService = (
  cartItemId: string,
  payload: { quantity: number }
) => {
  return axios.put(`${URL}/cart-item/${cartItemId}/quantity`, payload);
};
